import CustomDatePicker from 'app/views/common-components/date-pickers/CustomDatePicker'

export const FormDatePickerPrint = (props) => {
  return (
    <CustomDatePicker
      {...props}
      readOnly
      sx={{ textAlign: 'left', marginTop: '8px' }}
    />
  )
}
